import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { DEFAULT_SIDEPANEL_WIDTH } from "@styles/common-styles";
/**
 * Component for rendering a side panel in the Faro Table
 */
export function FaroTableSidePanel(t0) {
  const $ = _c(7);
  const {
    isSidePanelOpened: t1,
    sidePanelContentWidth: t2,
    sidePanelContent
  } = t0;
  const isSidePanelOpened = t1 === undefined ? false : t1;
  const sidePanelContentWidth = t2 === undefined ? DEFAULT_SIDEPANEL_WIDTH : t2;
  if (!sidePanelContent) {
    return null;
  }
  const t3 = isSidePanelOpened ? 1 : 0;
  const t4 = isSidePanelOpened ? "visible" : "hidden";
  const t5 = isSidePanelOpened ? `${sidePanelContentWidth}px` : "0";
  let t6;
  if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5) {
    t6 = {
      overflow: "hidden",
      opacity: t3,
      visibility: t4,
      width: t5,
      transition: "0.3s ease-in-out",
      mt: "55px"
    };
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== sidePanelContent || $[5] !== t6) {
    t7 = <Box sx={t6}>{sidePanelContent}</Box>;
    $[4] = sidePanelContent;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
}